module.exports = __webpack_public_path__ + "static/media/en-data-roaming-other_5.4b2d8350.png";